import { render, staticRenderFns } from "./ModalFormule.vue?vue&type=template&id=d3b608d8&scoped=true"
import script from "./ModalFormule.vue?vue&type=script&lang=ts"
export * from "./ModalFormule.vue?vue&type=script&lang=ts"
import style0 from "./ModalFormule.vue?vue&type=style&index=0&id=d3b608d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b608d8",
  null
  
)

export default component.exports